import React from 'react';

/**
 * The outlined label above each section heading — "ماذا نقدم؟",
 * "منهجية بناء المحتوى", "الخبرة و الموثوقية", "مركز الدعم".
 *
 * Two treatments, both from the design:
 *
 *   outline — 32px tall, white ground, a 0.8px border in the brand's first
 *             stop, 14px regular text in #222, and a 16px icon.
 *   tint    — the catalogue hero's "مكتبة Learning-Go Education": 29px tall on
 *             the #edf2ff ground, a half-strength border, and 12.5px text
 *             in the brand blue rather than near-black.
 *
 * A variant rather than a handful of classes passed in from the caller. Two
 * Tailwind utilities of the same kind are settled by the order the stylesheet
 * happens to put them in, not by the order they appear in the attribute, so an
 * override written that way holds only by luck.
 */

const VARIANTS = {
    outline: 'tw-h-8 tw-border-v2-brand-edge tw-bg-white tw-text-v2-sm tw-text-v2-text-strong',
    tint: 'tw-h-[29px] tw-border-v2-brand-ring/50 tw-bg-v2-brand-tint tw-text-[12.5px] tw-text-v2-brand',
    // The contact page's "مركز الدعم": the tint pill a size up — 30px tall,
    // 14px text tracked out to 0.35 and set as an eyebrow, led by a 5px dot
    // rather than a glyph. Its own variant because `tint` already sets a size
    // and a tracking, and a second `text-*` from the caller would be settled by
    // the stylesheet's order rather than by the attribute's.
    dot: 'tw-h-[30px] tw-border-v2-brand-ring/50 tw-bg-v2-brand-tint tw-text-[14px] tw-uppercase tw-tracking-[0.35px] tw-text-v2-brand',
};

const Pill = ({ icon, variant = 'outline', className = '', children }) => (
    <span
        className={
            'tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full ' +
            'tw-border-[0.8px] tw-px-4 tw-font-normal ' +
            `${VARIANTS[variant] ?? VARIANTS.outline} ${className}`
        }
    >
        {icon}
        {children}
    </span>
);

export default Pill;
